// @flow
import React from "react";
import withStyles from "elevate-ui/withStyles";
import Autorenew from "elevate-ui-icons/Autorenew";
import Button from "elevate-ui/Button";
import Search from "elevate-ui-icons/Search";
import NavigateNext from "elevate-ui-icons/NavigateNext";

type Props = {
  activeStep: string,
  classes: Object,
  handleFilterToggle: Function,
  handleNextSection: Function,
  handleReset: Function,
};

const FilterBottomBar = ({
  activeStep,
  classes,
  handleFilterToggle,
  handleNextSection,
  handleReset,
}: Props) => (
  <div className={classes.buttonContainer}>
    <div className={classes.buttonRow}>
      <div>
        <Button
          isOutlined
          color="primary"
          icon={<Autorenew />}
          className={classes.noBorderButton}
          onClick={handleReset}
        >
          Start Over
        </Button>
      </div>

      <div>
        {activeStep === "Review" ? (
          <Button
            icon={<Search />}
            iconAlign="right"
            color="primary"
            onClick={handleFilterToggle}
          >
            See Results
          </Button>
        ) : (
          <Button
            icon={<NavigateNext />}
            iconAlign="right"
            color="primary"
            onClick={handleNextSection}
          >
            Next
          </Button>
        )}
      </div>
    </div>
  </div>
);

const styles = (theme) => ({
  buttonContainer: {
    flex: "0 0 auto",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    width: "100%",
    padding: "8px 24px",
    backgroundColor: theme.colors.gray["100"],
    boxShadow:
      "0 -6px 9px -2px rgba(0,0,0,.07), 0 -9px 7px 0 rgba(0,0,0,0.01), 0 -3px 4px 0 rgba(0,0,0,.02)",
    zIndex: theme.zIndex["modalBottomBar"],
  },
  buttonRow: {
    display: "flex",
    flexFlow: "row wrap",
    justifyContent: "space-between",
    alignItems: "center",
  },
  noBorderButton: {
    borderColor: "transparent",
  },
});

export default withStyles(styles, { name: "FilterBottomBar" })(FilterBottomBar);
